import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_39: FaireProductEntity = {
  token: "legacy_prod_abbott-39",
  type: "product",
  name: 'All Purpose Scissors Red 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c1981a02083677591834e44f26fe6eb17894d8521003e2960aa36684083c467.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
